import React from 'react';
import ReactECharts from 'echarts-for-react';
import {
  getPartnerNarrativeColor,
  shortenNarrativeLabel,
  buildChartTheme,
  truncateChartLabel,
} from './chartTheme';
import useLaptopCompact from './useLaptopCompact';
import ChartEmptyState from './ChartEmptyState';

const partnerSplitLine = {
  lineStyle: { type: 'dashed', color: 'rgba(148, 163, 184, 0.32)', width: 1 },
};

const UserNarrativeStackedChart = ({
  data,
  legendNames,
  renderZeroWhenEmpty = false,
  emptyStateTitle = 'No activity for this period',
  emptyStateSubtitle = 'Try changing the time filter.',
  emptyStateCompact = false,
}) => {
  const isLaptopCompact = useLaptopCompact();
  const theme = buildChartTheme(isLaptopCompact);

  const hasData = Array.isArray(data) && data.length > 0;
  if (!hasData && !renderZeroWhenEmpty) {
    return (
      <ChartEmptyState
        title={emptyStateTitle}
        subtitle={emptyStateSubtitle}
        compact={emptyStateCompact}
      />
    );
  }
  const normalizedData = hasData ? data : [{ name: '', 'Narrative Runs': 0 }];
  const categories = normalizedData.map((d) => d.name);
  const keys = legendNames || Object.keys(normalizedData[0]).filter((k) => k !== 'name');

  const series = keys.map((key, idx) => ({
    name: shortenNarrativeLabel(key),
    type: 'bar',
    stack: 'total',
    barMaxWidth: 44,
    data: normalizedData.map((row) => row[key] || 0),
    itemStyle: { color: getPartnerNarrativeColor(key, idx) },
  }));
  const options = {
    animation: false,
    grid: { ...theme.gridWithLegend, bottom: isLaptopCompact ? 90 : 102 },
    tooltip: {
      ...theme.tooltipBase,
      trigger: 'axis',
      axisPointer: { type: 'shadow' },
    },
    legend: {
      ...theme.legendBase,
      type: 'scroll',
      bottom: 0,
      left: 'center',
      icon: 'roundRect',
      textStyle: { fontSize: theme.fs(11), color: '#374151' },
      itemGap: isLaptopCompact ? 12 : 14,
      formatter: (name) => truncateChartLabel(name, 18),
    },
    xAxis: {
      type: 'category',
      data: categories,
      axisLabel: {
        ...theme.axisLabel,
        rotate: categories.length > 5 ? 18 : 0,
        formatter: (value) => truncateChartLabel(value, 15),
        margin: 14,
      },
    },
    yAxis: {
      type: 'value',
      name: 'Narrative Runs',
      nameTextStyle: theme.axisNameStyle,
      axisLabel: theme.axisLabel,
      min: 0,
      splitLine: partnerSplitLine,
    },
    series,
  };

  return (
    <ReactECharts
      option={options}
      style={{ height: `${isLaptopCompact ? 338 : 360}px`, width: '100%' }}
      opts={{ renderer: 'canvas' }}
    />
  );
};

export default UserNarrativeStackedChart;
